module.exports = __webpack_public_path__ + "static/img/biglogo.27e84d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/biglogo.png
// module id = auxu
// module chunks = 1